export const ScheduleMode = {
  Instant: 'instant',
  Scheduled: 'scheduled',
};

export const CreatedBy = {
  System: 'system',
  User: 'user',
};

export const DeliveryStatus = {
  Sending: 'sending',
  Sent: 'sent',
  Queued: 'queued',
  Failed: 'failed',
};
